import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { Ship, Lock, Mail } from 'lucide-react';

const Login = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });

      if (response.data.access_token) {
        localStorage.setItem('nautilus_token', response.data.access_token);
        localStorage.setItem('nautilus_user', JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        toast.success('Login realizado com sucesso!');
        navigate('/');
      } else {
        toast.error('Resposta inesperada do servidor');
      }
    } catch (error) {
      if (error.response) {
        // Erro do servidor com resposta
        const status = error.response.status;
        const detail = error.response.data?.detail || '';
        if (status === 401 || status === 400) {
          toast.error('Credenciais inválidas');
        } else if (status === 429) {
          toast.error('Muitas tentativas. Aguarde alguns minutos.');
        } else if (status === 423) {
          toast.error('Conta bloqueada temporariamente. Aguarde 15 minutos.');
        } else {
          toast.error(`Erro no servidor (${status}): ${detail || 'Tente novamente'}`);
        }
      } else if (error.request) {
        // Sem resposta do servidor — esgotou as 4 tentativas de cold-start retry
        toast.error('Servidor indisponível após várias tentativas. Aguarde 1-2 minutos e tente novamente.');
      } else {
        toast.error('Erro ao conectar. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'linear-gradient(135deg, #0052CC 0%, #1E88E5 100%)'
    }}>
      <Card className="w-full max-w-md p-8 shadow-2xl" data-testid="login-card">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-blue-600 p-4 rounded-full mb-4">
            <Ship size={48} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Nautilus OS</h1>
          <p className="text-gray-600 text-center font-medium">Navegue com Precisão. Cresça com Inteligência.</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 text-gray-400" size={20} />
              <Input
                data-testid="email-input"
                type="email"
                name="email"
                autoComplete="email"
                placeholder="admin@nautilus.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 h-12"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Senha
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-3 text-gray-400" size={20} />
              <Input
                data-testid="password-input"
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 h-12"
                required
              />
            </div>
          </div>

          <Button
            data-testid="login-button"
            type="submit"
            className="w-full h-12 text-lg font-semibold bg-blue-600 hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

      </Card>
    </div>
  );
};

export default Login;
